$(document).ready(function () {
  function setPageHeadingPadding() {
    if ($('.pageContent-image').length > 0) {
      if ($(window).innerWidth() > 1023) {
        var wrapperPadding = ($('.pageContent-image').innerWidth() + 30) / 16 + 'rem';

        $('.pageHeading-wrapper').css('padding-right', wrapperPadding);
      } else {
        $('.pageHeading-wrapper').removeAttr('style');
      }
    }
  }

  $(window).on('load', setPageHeadingPadding);
  $(window).on('resize', setPageHeadingPadding);
});



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/PageContent.js